(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('settings', {
        templateUrl: 'views/components/views/settings/settings.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['stateService', 'utilityService', 'settingsService', 'rememberService', function (stateService, utilityService, settingsService, rememberService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let webPageName = stateService.getCurrentName();
            
            let variableNames = {
                filterval: ''
            };

            vm.model = {
                filterValueButtons: [
                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => clear('filterval') }
                ],
                setting: {},
                itemsListSettings: []
            };

            // #endregion VARIABLES & DEFINITIONS

            // #region LOAD PROCEDURE FUNCTION CALLS

            async function loadSetting() {
                vm.model.setting = (await settingsService.getSetting())[0];
            }

            async function loadSettings() {
                // BJS 20260313 - Modified webpage_name to webpageName to match variable defined in this component.
                vm.model.itemsListSettings = await settingsService.listSettings({ webpageName: webPageName });
            }

            // #endregion LOAD PROCEDURE FUNCTION CALLS

            // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

            function rememberFunc(id) {
                Object.keys(variableNames).forEach((key) => {
                    variableNames[key] = 'w_' + webPageName + '.' + key;
                });

                if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

                let variableValue = null;

                switch (id) {
                    case 'filterval':
                        if (utilityService.validateParmsValue(vm.model.setting[id], true) !== true) return;

                        variableValue = vm.model.setting[id];
                        break;
                    default:
                        break;
                }

                return rememberService.remember(variableNames[id], variableValue);
            }
            
            // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

            // #region RESET BUTTON FUNCTION

            function clear(id) {
                switch (id) {
                    case 'filterval':
                        vm.model.setting.filterval = '';

                        if (vm.model.setting.filterval === '') rememberFunc('filterval');
                        break;
                    default:
                        break;
                }
            }

            // #endregion RESET BUTTON FUNCTION

            // #region FIELD CHANGE MULTI FUNCTIONS

            vm.onChanged = function (value, id) {
                switch (id) {
                    case 'filterval':
                        if (utilityService.validateWatchValue(value, vm.model.setting.filterval) !== true) return;

                        vm.model.setting.filterval = value;

                        if (utilityService.validateParmsValue(vm.model.setting.filterval, true) !== true) return;

                        if (vm.model.setting.filterval === '') rememberFunc('filterval');
                        break;
                    default:
                        utilityService.setValueToVariable(value);
                        break;
                }
            };

            // #endregion FIELD CHANGE MULTI FUNCTIONS

            // #region ON BLUR MULTI FUNCTIONS

            vm.onBlur = function (id) {
                switch (id) {
                    case 'filterval':
                        if (utilityService.validateParmsValue(vm.model.setting.filterval, true) !== true) return;

                        if (vm.model.setting.filterval > '') rememberFunc('filterval');
                        break;
                    default:
                        break;
                }
            };

            // #endregion ON BLUR MULTI FUNCTIONS
            
            // #region ON INIT FUNCTION

            vm.$onInit = function () {
                loadSetting();
                loadSettings();
            }

            // #endregion ON INIT FUNCTION

        }]
    });
})();
